<template>

	<a-card :bordered="false" class="dashboard-bar-line header-solid">
		<template #title>
			<a-row :gutter="24" type="flex" align="stretch">
				<a-col :span="24" :lg="8" class="mb-24">
					<h6>订单日报表</h6>
				</a-col>
				<a-col :span="24" :lg="12" class="mb-24">
					<a-range-picker @change="change" format="YYYY-MM-DD" v-model="selectDate">
					</a-range-picker>
				</a-col>
			</a-row>
		</template>
		<!-- <template #extra>
			<a-badge color="primary" class="badge-dot-primary" text="Traffic" />
			<a-badge color="primary" class="badge-dot-secondary" text="Sales" />
		</template> -->
		<chart-line :key="key" :height="310" :data="lineChartData"></chart-line>
	</a-card>

</template>

<script>
import moment from 'moment';
// Bar chart for "Active Users" card.
import ChartLine from '../Charts/ChartLine';
import { getTabledata } from '../../utils/user';
export default ({
	props: {
		start: {
			type: String,
			default: "",
		},
		end: {
			type: String,
			default: "",
		}
	},
	components: {
		ChartLine,
	},
	data() {
		return {
			key: 0,
			selectDate: [],
			startTime: "",
			endTime: "",
			// Data for line chart.
			lineChartData: {
				labels: [],
				datasets: [{
					label: "order",
					tension: 0.5,
					borderWidth: 0,
					pointRadius: 3,
					borderColor: "#1890FF",
					borderWidth: 3,
					data: [],
					maxBarThickness: 6
				},
					// {
					// 	label: "Websites",
					// 	tension: 0.4,
					// 	borderWidth: 0,
					// 	pointRadius: 0,
					// 	borderColor: "#B37FEB",
					// 	borderWidth: 3,
					// 	data: [30, 90, 40, 140, 290, 290, 340, 230, 400],
					// 	maxBarThickness: 6
					// }
				],
			},
		}
	},
	mounted() {
		this.startTime = moment().startOf('month').format("YYYY-MM-DD HH:mm:ss");
		this.endTime = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
		this.getData(this.startTime, this.endTime)
	},
	methods: {
		getData(startTime, endtime) {
			let start = moment(startTime).format("YYYY-MM-DD");
			let end = moment(endtime).format("YYYY-MM-DD");
			let days = moment(end).diff(moment(start), 'days')
			let params = {}
			params.startTime = start
			params.endTime = end
			params.page = 1
			params.limit = 9999999
			getTabledata(params).then(data => {
				if (data.code === 0) {
					this.lineChartData.labels = []
					this.lineChartData.datasets[0].data = []
					for (let i = 0; i <= days; i++) {
						this.lineChartData.labels.push(moment(start).add(i, 'days').format("YYYY-MM-DD"))
						this.lineChartData.datasets[0].data.push(0);
						data.page.list.forEach(e => {
							if (moment(moment(e.time).format("YYYY-MM-DD")).diff(moment(this.lineChartData.labels[i]), 'days') == 0) {
								parseInt(this.lineChartData.datasets[0].data[i]) > 0 ?
									this.lineChartData.datasets[0].data[i] = parseInt(this.lineChartData.datasets[0].data[i]) + 1 :
									this.lineChartData.datasets[0].data[i] = 1
							}
						});
					}
					this.key = this.key + 1
				}
			})
				.catch(err => {
					console.info("err:", err)
				});
		},
		change() {
			console.info(moment(this.selectDate[0]).format("YYYY-MM-DD") + " -- " + moment(this.selectDate[1]).format("YYYY-MM-DD"));
			this.getData(this.selectDate[0].format("YYYY-MM-DD") + " 00:00:00", this.selectDate[1].format("YYYY-MM-DD") + " 23:59:59")
		},
	},
})

</script>